import React from 'react';
import { Label } from 'angieslist-react-components';

type Props = {
  addClass: string,
  customText: string,
};

export const AdvertiserOnlyPillComponent = ({ addClass, customText }: Props) => (
  <Label
    className={`Advertiser-Only-Pill ${addClass}`}
    bsStyle="default"
    style={{
      background: '#f8e5cd',
      border: 'none',
      padding: '.3em 1em',
      fontSize: '.7em',
      marginLeft: '.5em',
      marginTop: '.25em',
    }}
  >
    {customText}
  </Label>
);

export default(AdvertiserOnlyPillComponent);



// WEBPACK FOOTER //
// ./src/modules/home/browser/components/AdvertiserOnlyPill.js